export const service_planing = [
    {
        name: "initial plan",
        price: 100,
        description: "",
        listOffer: [
          "3-4 section only", 
            "only 1 image in banner",
            " Upto 14  product only",
            "up to 4 icons",
            "only one or two whatsApp link", 
            "add 50 Rs in monthly subscription then you can  manage all product from google sheet, from your mobile phone or computer",
            "(buy website: 8000 Rs)"
        ]
    },
    {
        name: "Silver plan",
        price: 300,
        description: "",
        listOffer: [
            "1 e-commerce feature (add to wish list or product detail)",
            "3-6 section ",
            "20-25 product with whatsapp button",
            "Phone, Email and whatsapp link",
            "1 page in banner",
            "google map in website",
            "share website on social media for marketing",
            "add 50 Rs in monthly subscription, manage all product from google sheet from your mobile phone or computer",
            "O.T.Pay. : ₹30/product,   ₹100/section,  ₹1000/page ",
            "(buy website: 13500 Rs)"



        ]
    },
    {
        name: "Gold plan",
        price: 400,
        description: "",
        listOffer: [
            "dark/light mode",
            "only 2 Language button: in Eglish, hindi, etc.",
            "Product filter functionality (such as birthday, anniversary)",
            "3-6 section ",
            "20-25 product with whatsapp button ",
            "Phone, Email and whatsapp link",
            "1 Images in banner ", 
            "share website on social media for marketing",
            "google map in website",
            "O.T.Pay. : 500₹/language, 700₹/banner image,  ₹30/product, ₹100/section,  ₹1000/page ",
            "(buy website: 16000 Rs)"

        ]
    },
    {
        name: "Diamond plan",
        price: 500,
        description: "",
        listOffer: [
            "2 e-commerce feature (add to wish list and product detail)",
            "dark / light mode ",
            "2 multi Language button: in Eglish, hindi, etc.",
            "advance  Product filter functionality",
            "cateogry buttons for show only particular products (less than 100 Products) ",
            "3-6 section ",
            "share website on social media for marketing",
            "unlimited product with whatsapp button ",
            "Phone, Email and whatsapp link",
            "2-4 Images in banner with carosel", 
            "google map in website",
            "add 50 Rs in monthly subscription, manage all product from google sheet from your mobile phone or computer",
            "O.T.Pay. : 500₹/language, 700₹/banner_image, ₹100/section,  ₹1500/page ",
            "(buy website: 24000 Rs )"

        ]
    },

]

// 500₹/language
// ₹100/section
//  ₹1500/page
// section banner 700 rs 
// eccomerce feature 1800 rs 

